import styled from 'styled-components'

import { mergeStyles } from '@hozana/styling/mergeStyles'

import { Li, TLiProps } from 'elements/layout/Li'
import { Ellipsis } from 'elements/text/Ellipsis'

export type TTabProps = {
  selected?: boolean
} & TLiProps

export const Tab = styled(Li).attrs<TTabProps, TTabProps>(({ theme, selected, style }) => ({
  role: 'tab',
  style: mergeStyles(style, {
    color: selected ? theme.colors.darkBlue : theme.colors.black50,
  }),
}))`
  display: inline-block;
  text-align: center;
  padding: 0 !important;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  & ${Ellipsis} {
    display: inline-block;
    text-align: center;
    padding: 10px 1em;
    margin: auto;
  }
  &:first-child ${Ellipsis} {
    border-left: none;
  }
  &:focus,
  &:hover {
    color: ${(props) => props.theme.colors.darkBlue};
    border-bottom: 2px solid ${(props) => props.theme.colors.black10};
  }
`
